import PropTypes from 'prop-types';
import React, { Component } from 'react';
import moment from 'moment';
import { SingleDatePicker } from 'react-dates';
import cx from 'classnames';

const propTypes = {
  input: PropTypes.object,
  range: PropTypes.object,
  meta: PropTypes.object,
  title: PropTypes.any,
  disabled: PropTypes.bool,
  isFullWidth: PropTypes.bool,
  displayFormat: PropTypes.string,
  dateForInitialVisibleMonth: PropTypes.string,
};

const defaultProps = {
  displayFormat: 'D MMMM YYYY',
  dateForInitialVisibleMonth: '',
};

class InputDatePicker extends Component {
  constructor(props) {
    super(props);
    this.state = {
      focused: false,
      date: props.input.value ? moment(props.input.value) : null,
      openDirection: 'down',
    };
    this.onFocusChange = this.onFocusChange.bind(this);
    this.onDateChange = this.onDateChange.bind(this);
    this.setRef = this.setRef.bind(this);
    this.isOutsideRange = this.isOutsideRange.bind(this);
    this.getInitialVisibleMonth = this.getInitialVisibleMonth.bind(this);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.input.value !== nextProps.input.value) {
      this.setState({
        date: nextProps.input.value ? moment(nextProps.input.value, 'YYYY-MM-DD') : null,
      });
    }
  }

  onFocusChange({ focused }) {
    const { y } = this.ref.getBoundingClientRect();
    const gap = document.documentElement.clientHeight - y;
    this.setState({ focused, openDirection: gap >= 340 ? 'down' : 'up' });
  }

  onDateChange(date) {
    this.setState({ date });
    this.props.input.onChange(date.format('YYYY-MM-DD'));
  }

  setRef(ref) {
    this.ref = ref;
  }

  getInitialVisibleMonth() {
    const { dateForInitialVisibleMonth } = this.props;
    let date = this.state.date;
    if (!date) {
      date = dateForInitialVisibleMonth !== '' ? moment(dateForInitialVisibleMonth) : moment();
    }

    return moment(date, 'MM YYYY');
  }

  isOutsideRange(date) {
    const { range } = this.props;
    return !date.isBetween(range.minDate, range.maxDate, 'day', '[]');
  }

  render() {
    const { focused, date, openDirection } = this.state;
    const {
      meta: { touched, error },
      title,
      disabled,
      isFullWidth,
      displayFormat,
    } = this.props;

    const inputClasses = cx({
      'input-date-picker': true,
      'input-date-picker--width-full': isFullWidth,
      'input-date-picker--state-error': touched && error,
      'input-date-picker--state-disabled': disabled,
      'input-date-picker--state-active': date,
    });

    return (
      <div className={inputClasses} ref={this.setRef}>
        {title && <span className="input-date-picker__title">{title}</span>}
        <div className="input-date-picker__field">
          <SingleDatePicker
            id="date_input"
            focused={focused}
            date={date}
            displayFormat={displayFormat}
            numberOfMonths={1}
            initialVisibleMonth={this.getInitialVisibleMonth}
            onFocusChange={this.onFocusChange}
            onDateChange={this.onDateChange}
            isOutsideRange={this.isOutsideRange}
            openDirection={openDirection}
            placeholder=""
            hideKeyboardShortcutsPanel
            readOnly
          />
        </div>
        <span className="input-date-picker__icon" />
      </div>
    );
  }
}

InputDatePicker.propTypes = propTypes;
InputDatePicker.defaultProps = defaultProps;

export default InputDatePicker;
